import { ReactElement, ReactNode } from 'react';
import { Backdrop, Fade, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';

// Styles
import styles from './Modal.module.scss';
import { ModalFlexContainer } from '../../hooks/StyledComponents';

// Types
interface IProps {
  children?: ReactNode;
  errorMessage?: string;
  isOpen: boolean;
  onClose?(): void;
  title?: string;
}

export const Modal = (props: IProps): ReactElement => {
  const { children, isOpen, errorMessage, onClose, title } = props;

  const handleClose = (): void => {
    // Optional callback.
    onClose?.();
  };

  return (
    <ModalFlexContainer
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={isOpen}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={isOpen}>
        <div className={styles.wrapper}>
          {/* Error message */}
          {errorMessage && <div className={styles.error}>{errorMessage}</div>}

          {/* Header content */}
          <div className={styles.header}>
            {title && (
              <h2 id="transition-modal-title" className={styles.activityTitle}>
                {title}
              </h2>
            )}
            <IconButton className={styles.close} title="Close" onClick={handleClose} size="large">
              <Close />
            </IconButton>
          </div>

          {/* Main content */}
          <div className={styles['content-wrapper']}>{children}</div>
        </div>
      </Fade>
    </ModalFlexContainer>
  );
};
